import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "button", "inputTemplate", "counterTemplate",
    "repsInput", "setsInput", "repsDisplay", "setsDisplay", "positionInput"
  ]
  static values = {
    type: String,
    id: Number,
    name: { type: String, default: "" },
    supportsReps: { type: Boolean, default: false },
    supportsSets: { type: Boolean, default: false },
    color: { type: String, default: "indigo" },
    active: { type: Boolean, default: false },
    reps: { type: Number, default: 5 },
    sets: { type: Number, default: 3 }
  }

  toggle() {
    this.activeValue = !this.activeValue

    if (this.activeValue) {
      this.activate()
    } else {
      this.deactivate()
    }

    this.dispatch("toggled", {
      detail: {
        active: this.activeValue,
        type: this.typeValue,
        id: this.idValue,
        name: this.nameValue,
        color: this.colorValue,
        reps: this.repsValue,
        sets: this.setsValue,
        supportsReps: this.supportsRepsValue,
        supportsSets: this.supportsSetsValue
      }
    })
  }

  // Called from cart remove button via practice-log controller
  deactivateFromCart() {
    if (this.activeValue) {
      this.activeValue = false
      this.deactivate()
      this.dispatch("toggled", {
        detail: {
          active: false,
          type: this.typeValue,
          id: this.idValue,
          name: this.nameValue,
          color: this.colorValue,
          reps: this.repsValue,
          sets: this.setsValue,
          supportsReps: this.supportsRepsValue,
          supportsSets: this.supportsSetsValue
        }
      })
    }
  }

  activate() {
    const btn = this.buttonTarget
    const color = this.colorValue

    btn.classList.remove("border-gray-200", "bg-white", "text-gray-600")
    btn.classList.add(`border-${color}-500`, `bg-${color}-100`, `text-${color}-800`, "font-semibold", "shadow-sm")

    // Inject hidden inputs from template
    const inputClone = this.inputTemplateTarget.content.cloneNode(true)
    this.element.appendChild(inputClone)

    // Show counter if item supports reps or sets
    if (this.supportsRepsValue || this.supportsSetsValue) {
      const counterClone = this.counterTemplateTarget.content.cloneNode(true)
      this.element.appendChild(counterClone)
      this.updateInputValues()
    }
  }

  deactivate() {
    const btn = this.buttonTarget
    const color = this.colorValue

    btn.classList.remove(`border-${color}-500`, `bg-${color}-100`, `text-${color}-800`, "font-semibold", "shadow-sm")
    btn.classList.add("border-gray-200", "bg-white", "text-gray-600")

    // Remove injected elements (hidden inputs and counter divs)
    const toRemove = []
    this.element.childNodes.forEach(node => {
      if (node.nodeType === 1 && node.tagName !== "BUTTON" && node.tagName !== "TEMPLATE") {
        toRemove.push(node)
      }
    })
    toRemove.forEach(el => el.remove())
  }

  incrementReps() {
    this.repsValue = Math.min(this.repsValue + 1, 99)
    this.updateInputValues()
    this._dispatchUpdate()
  }

  decrementReps() {
    this.repsValue = Math.max(this.repsValue - 1, 1)
    this.updateInputValues()
    this._dispatchUpdate()
  }

  incrementSets() {
    this.setsValue = Math.min(this.setsValue + 1, 20)
    this.updateInputValues()
    this._dispatchUpdate()
  }

  decrementSets() {
    this.setsValue = Math.max(this.setsValue - 1, 1)
    this.updateInputValues()
    this._dispatchUpdate()
  }

  updateInputValues() {
    if (this.hasRepsInputTarget) this.repsInputTarget.value = this.repsValue
    if (this.hasSetsInputTarget) this.setsInputTarget.value = this.setsValue
    if (this.hasRepsDisplayTarget) this.repsDisplayTarget.textContent = this.repsValue
    if (this.hasSetsDisplayTarget) this.setsDisplayTarget.textContent = this.setsValue
  }

  _dispatchUpdate() {
    this.dispatch("updated", {
      detail: {
        type: this.typeValue,
        id: this.idValue,
        reps: this.repsValue,
        sets: this.setsValue
      }
    })
  }
}
